import { Button } from "@workspace/ui/components/button";
import { cn } from "@workspace/ui/lib/utils";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import { LogoIcon } from "@/components/logo-icon";
import { UserAvatarMenu } from "@/components/user-avatar-menu";

type PageHeaderProps = {
  backHref?: string;
  backLabel?: string;
  embedded?: boolean;
};

export function PageHeader({
  backHref,
  backLabel,
  embedded = false,
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        "right-0 left-0 z-50 h-14 bg-background/95 backdrop-blur-md",
        embedded ? "relative" : "fixed top-0"
      )}
    >
      <div className="flex h-full items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-3">
          <Link
            className="flex items-center justify-center"
            href="/"
            title="Home"
          >
            <LogoIcon />
          </Link>

          {backHref && (
            <>
              <span className="text-muted-foreground text-sm">|</span>
              <Button
                asChild
                className="h-auto gap-1.5 px-2 py-1 text-sm"
                variant="ghost"
              >
                <Link href={backHref}>
                  <ArrowLeft className="size-4" />
                  {backLabel ? `Back to ${backLabel}` : "Back"}
                </Link>
              </Button>
            </>
          )}
        </div>

        <div className="flex items-center gap-2">
          <UserAvatarMenu align="end" avatarSize="sm" side="bottom" />
        </div>
      </div>
    </header>
  );
}
